class TootoFooterMenus extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const trigger = event.target.closest('.tooto-footer__menu-trigger');
    if (!trigger || !this.contains(trigger) || window.matchMedia('(min-width: 768px)').matches) return;

    const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
    if (willOpen) {
      this.querySelectorAll('.tooto-footer__menu-trigger').forEach((item) => item.setAttribute('aria-expanded', 'false'));
    }
    trigger.setAttribute('aria-expanded', String(willOpen));
  };
}

if (!customElements.get('tooto-footer-menus')) {
  customElements.define('tooto-footer-menus', TootoFooterMenus);
}
